"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RatingOptionStyled = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _focusRing = require("../../../util/focusRing");
var _withFocusClassName = require("../../../util/withFocusClassName");
const RatingOptionStyled = (0, _withFocusClassName.withFocusToggleClassName)((0, _styled.default)("div")`
    height: var(--smar--sds--rating--icon--size, 20px);
    width: var(--smar--sds--rating--icon--size, 20px);
    // Set the icon size to the size of the RatingOption.
    // TODO(TBL-0229): Change this CSS Custom Property "--lodestar-icon-size" to the
    // new convention.
    --lodestar-icon-size: var(--smar--sds--rating--icon--size);
    display: flex;
    align-items: center;
    justify-content: center;
    // For the absolutely-positioned HiddenInputs.
    position: relative;

    ${_ref => {
  let {
    themeMode
  } = _ref;
  return (0, _focusRing.getFocusRingStyles)({
    theme: themeMode,
    offset: 4,
    radius: 4,
    includeFocusPseudoClass: true,
    focusSelector: "focus-within"
  });
}}
`);
exports.RatingOptionStyled = RatingOptionStyled;
//# sourceMappingURL=RatingOptionStyled.js.map